module.exports = __webpack_public_path__ + "img/restore.fab3e7fc.svg";